const NAME = "ANNOTATIONS_ANALYSIS_PAGE";

export default NAME;
